import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { orderByDate } from "../../utils/sortFunctions";
import { disciplineAllegations } from "../../utils/discipline";
import { FiExternalLink } from "react-icons/fi";
import SortControls from "../SortControls/SortControls";
import PillSortButton from "../PillInput/PillSortButton";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import { FaFilter } from "react-icons/fa";
import AutoCompleteInput from "../AutoCompleteInput/AutoCompleteInput";

const consolidatedList = orderByDate(
  [...disciplineAllegations].map((entry) => {
    entry.sortDate = entry.referralDate
      ? entry.referralDate
      : entry.referralDate;
    return entry;
  }),
  "sortDate"
);

const uniqueLicensees = [
  "All",
  ...new Set(disciplineAllegations.map((allegation) => allegation.vb)),
];

const DisciplineTable = ({ ...props }) => {
  const isMobile = useMediaQuery({ maxWidth: 990 });
  const [searchOrderBy, setSearchOrderBy] = useState("sortDate");
  const [searchOrderDirection, setSearchOrderDirection] = useState("desc");
  const [filteredList, setFilteredList] = useState(consolidatedList);
  const [modalOpen, toggleModal] = useState(false);
  const [selectedLicensee, setSelectedLicensee] = useState(null);

  const applySorting = () => {
    const sorted = [...consolidatedList].sort((a, b) => {
      if (searchOrderBy === "vb") {
        return searchOrderDirection === "asc"
          ? a.vb.localeCompare(b.vb)
          : b.vb.localeCompare(a.vb);
      } else if (searchOrderBy === "sortDate") {
        return searchOrderDirection === "asc"
          ? new Date(a.sortDate) - new Date(b.sortDate)
          : new Date(b.sortDate) - new Date(a.sortDate);
      }
      return 0;
    });
    setFilteredList(sorted);
  };

  const setListOrder = (filterId) => {
    if (filterId === searchOrderBy && searchOrderDirection === "asc") {
      setSearchOrderDirection("desc");
    } else {
      setSearchOrderBy(filterId);
      setSearchOrderDirection("asc");
    }
  };

  const applyFilters = (licenseeFilter) => {
    let filtered = consolidatedList;
    if (licenseeFilter !== "All") {
      setSelectedLicensee(licenseeFilter);
      filtered = filtered.filter((item) => item.vb === licenseeFilter);
    } else {
      setSelectedLicensee(null);
    }
    setFilteredList(filtered);
  };

  useEffect(() => {
    applySorting();
  }, [searchOrderBy, searchOrderDirection, applySorting]);

  return (
    <>
      <div className="flexContainer mobileCol justifyBetween alignEnd">
        <SortControls>
          <PillSortButton
            id="sortDate"
            label="Referral Date"
            active={searchOrderBy === "sortDate"}
            order={searchOrderDirection}
            clickEvt={() => setListOrder("sortDate")}
          />
          <PillSortButton
            id="vb"
            label="Licensee"
            active={searchOrderBy === "vb"}
            order={searchOrderDirection}
            clickEvt={() => setListOrder("vb")}
          />
        </SortControls>

        <Button
          id="filterBtn"
          icon={<FaFilter />}
          size="sm"
          clickEvt={() => toggleModal(!modalOpen)}
          text="Search Result"
        />
      </div>

      {modalOpen && (
        <Modal closeEvt={() => toggleModal(!modalOpen)}>
          <div>
            <h2>Filter Options</h2>
            <div>
              <div style={{ marginBottom: `.5rem` }}>
                <span className="bold">Licensee</span>
              </div>
              <AutoCompleteInput
                options={uniqueLicensees}
                placeholder="Search Licensee"
                value={selectedLicensee || ""}
                onChange={(value) => applyFilters(value)}
              />
            </div>
          </div>
        </Modal>
      )}

      <div className="overflowContainer">
        {!isMobile ? (
          <table>
            <thead>
              <tr>
                <th>Licensee</th>
                <th>Referral Date</th>
                <th>Next Steps</th>
              </tr>
            </thead>

            <tbody>
              {filteredList.map((row, i) => (
                <tr>
                  <td>
                    <a href={row.link} title={row.vb} className="linkHeader">
                      <FiExternalLink
                        style={{
                          verticalAlign: "center",
                          marginRight: ".5rem",
                          fontSize: `1.5rem`,
                        }}
                      />
                      {row.vb}
                    </a>
                  </td>
                  <td>{row.referralDate}</td>
                  <td>
                    {row.nextSteps ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: row.nextSteps }}
                      />
                    ) : (
                      <span>---</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            {filteredList.map((row) => (
              <div className="tile">
                <div>
                  <span className="label">Referral Date: </span>
                  <span>{row.referralDate}</span>
                </div>

                <div>
                  <span className="label">Licensee: </span>
                  <span>{row.vb}</span>
                </div>

                <div>
                  <span className="label">Next Steps: </span>
                  <span>
                    {row.nextSteps ? (
                      <span>{row.nextSteps}</span>
                    ) : (
                      <span>---</span>
                    )}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default DisciplineTable;
